import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from "@angular/common";
import { AssetService } from '../../services/asset.service';
import { DeviceTypeService } from '../../services/devicetype.service';
import { ApiResponse } from '../../admin/apiresponse';
import { Observable, Subscription } from 'rxjs';

declare var moment: any;

@Component({
    template: require('./admin.firmware.list.component.html'),
    providers: [AssetService, DeviceTypeService]
})

export class FirmwareListComponent implements OnInit {

    @ViewChild('grid') grid: any;
    @ViewChild('assetDetails') assetDetails: any;
    public message: string;
    public values: any[];
    public deviceType: string;
    public allowedSystemTypes: any[];
    public assets: any[] = [];
    public displayedAssets: any[] = [];
    public editIndex: number = -1;
    public defaultReleaseState: string;
    public apiResponseDeleteAsset: ApiResponse;
    public apiResponseGetAssets: ApiResponse;
    selectedAsset: any = {};
    showDialog = false;

    detailsOpenIndex = -1;
    public busySub: Subscription;
    public compatibleVersions: string;

    constructor(private assetService: AssetService, private deviceTypeService: DeviceTypeService) {
        
    }

    ngOnInit() {
        this.getDeviceTypes();
        
    }

    //ngAfterViewInit() {
    //    this.grid.nativeElement.then(() => {
    //        this.gridReady(this.grid.nativeElement);
    //    });
    //}


    gridReady(grid: any) {
        var defaultLocale: string = 'en-US';
        var datePipe = new DatePipe(defaultLocale);
        
        //grid.columns[0].renderer = cell =>
        //    cell.element.textContent = cell.row.index;

        grid.columns[4].renderer = cell =>
            cell.element.textContent = cell.data.split('@')[0];

        grid.columns[5].renderer = (cell: any) => {
            cell.element.innerHTML = datePipe.transform(cell.data, "MM/dd/yyyy");// moment(cell.data).format('YYYY-MM-DD');
        };

        //grid.rowDetailsGenerator = rowIndex => {
        //    var element = document.createElement('div');

        //    grid.getItem(rowIndex, (error, item) => {
        //        if (!error) {
        //            element.innerHTML = this.assetDetails.nativeElement.innerHTML;
        //            grid.scrollToStart(0);
        //        }
                
        //    });

        //    return element;
        //};
        
        //grid.items = (params: any, callback: Function) =>
        //    this.ht(`https://demo.vaadin.com/demo-data/1.0/people?index=${params.index}&count=${params.count}`)
        //        .subscribe(json => callback(json.result, json.size));
    }

    getDeviceTypes() {
        this.busySub = this.deviceTypeService.getDeviceTypes()
            .subscribe(
            success => {
                this.setGetResponse(success);
                
            },
            error => this.handleError(<any>error)
            );
    }

    public editAsset(id: number) {
        this.editIndex = 999;// this.selectedAsset.rowIndex;
        this.defaultReleaseState = this.selectedAsset.ReleaseState;
    }

    public cancelEdit(id: number) {
        this.editIndex = -1;
    }

    public updateAsset(id: number) {
        var currentAsset = this.selectedAsset;
        currentAsset.ReleaseState = this.defaultReleaseState;
        currentAsset.CompatibleVersions = this.compatibleVersions.split(",");
        this.busySub = this.assetService.Update(id, this.deviceType, currentAsset)
            .finally(() => {
                this.editIndex = -1;
            })
            .subscribe(
            success => {                
                //currentAsset.ReleaseState = this.defaultReleaseState;
                this.editIndex = -1;
                this.getAssets(this.deviceType);
            },
            error => {
                this.handleError(error);
                this.editIndex = -1;
            });
    }

    deleteAsset(index: number, assetType: string, version: string) {
        this.restApiResponses();
        this.busySub = this.assetService.Delete(this.deviceType, assetType, version)
            .subscribe(
            success => this.setDeleteResponse(success),
            error => this.handleError(<any>error)
            );
    }

    getAssets(deviceType: string) {
        this.restApiResponses();
        this.deviceType = deviceType;
        this.selectedAsset = {};
        this.displayedAssets = [];
        this.busySub = this.assetService
            .GetAssetsByDeviceType(deviceType)
            .subscribe(data => this.setGetResponseAssetList(data),
            error => this.handleError(<any>error)
        );

        //this.grid.items = (params: any, callback: Function) =>
        //    this.assetService
        //        .GetAssetsByDeviceType(deviceType)
        //        .subscribe(data => this.setGetResponseAssetList(data),
        //        error => this.setGetResponseAssetList(<any>error));
    }

    private filterAssets(event: any) {
        const filterText = (event.target as HTMLInputElement).value.toLowerCase();
        this.displayedAssets = this.assets.filter((asset: any) =>
            !filterText ||
            asset.AssetType.toLowerCase().indexOf(filterText) > -1 ||
            asset.Version.toLowerCase().indexOf(filterText) > -1
        );
    }

    private assetSelected(grid: any, rowIndex: number) {
        //this.selectedAsset = {};
        this.editIndex = -1;
        this.selectedAsset = grid.data;
        this.selectedAsset.rowIndex = rowIndex;
        this.compatibleVersions = (this.selectedAsset.CompatibleVersions == null ? "" : this.selectedAsset.CompatibleVersions.join());
        //var selection = grid.selection.selected();

        ////grid.setRowDetailsVisible(this.detailsOpenIndex, false);
        //if (selection.length === 1) {
        //    ////grid.selection.clear();
        //    //grid.setRowDetailsVisible(selection[0], true);
        //    this.detailsOpenIndex = selection[0];

        //    grid.getItem(selection[0], (error, item) => {
        //        if (!error) {
        //            this.selectedAsset = item;
        //            this.selectedAsset.Index = this.detailsOpenIndex;
        //        }
        //    });
        //}
    }

    private setGetResponse(resp: ApiResponse) {
        //this.queryInProgress = false;
        //this.apiResponse = resp;
        this.allowedSystemTypes = resp.data || [];
        if (this.allowedSystemTypes.length > 0) {
            this.deviceType = this.allowedSystemTypes[0].Name;
            this.getAssets(this.deviceType);
        }
    }

    private setGetResponseAssetList(resp: ApiResponse) {
        this.apiResponseGetAssets = resp;
        this.assets = resp.data || [];
        this.displayedAssets = this.assets;
    }

    private setDeleteResponse(resp: any) {
        this.showDialog = false;
        this.apiResponseDeleteAsset = resp;
        if (this.apiResponseDeleteAsset.statusCode === 204) {
            this.getAssets(this.deviceType);
        }
    }

    private restApiResponses() {
        this.apiResponseDeleteAsset = undefined;
        this.apiResponseGetAssets = undefined;
    }

    private handleError(resp: ApiResponse)
    {
        console.log(resp);
    }

    showDeleteConfirmDialog(index: number, assetType: string, version: string) {
        this.selectedAsset = this.assets.find(x => x.AssetType == assetType && x.Version == version);
        this.selectedAsset.Index = index;
        this.showDialog = true;
    }
}


// WEBPACK FOOTER //
// ./app/admin/firmware/admin.firmware.list.component.ts